import type { GridCell } from '@glideapps/glide-data-grid';

import { COLUMN_IDS } from '../constants';

import {
  isTotalCostCell,
  getTotalCostCellTemplate,
} from '../../CustomCell/TotalCost';
import { isSharePriceCell } from '../../CustomCell/SharePrice';
import { isTickerCell } from '../../CustomCell/Ticker';
import { isSharesCell } from '../../CustomCell/Shares';

const totalCostColIndex = COLUMN_IDS.indexOf('cost');

export const recalculateTotalCostCell = (row: (GridCell | undefined)[]) => {
  if (row.length !== COLUMN_IDS.length) return row;

  const [sharePriceCell = undefined] = row.filter(isSharePriceCell);
  const [sharesCell = undefined] = row.filter(isSharesCell);
  const [tickerCell = undefined] = row.filter(isTickerCell);

  if (!sharePriceCell || !sharesCell) return row;

  const { data: priceData } = sharePriceCell;
  const { data: sharesData } = sharesCell;

  const { value: price } = priceData;
  const { value: shares } = sharesData;

  let totalCost: number | null = null;

  if (typeof price === 'number' && typeof shares === 'number') {
    totalCost = price * shares;
  }

  const currencyISO =
    typeof tickerCell === 'undefined' ? null : tickerCell.data.currencyISO;

  // Find the total cost cell in the row if it exists
  const [currentTotalCostCell = {}] = row.filter(isTotalCostCell);

  const totalCostCell = {
    ...currentTotalCostCell,
    ...getTotalCostCellTemplate({
      value: totalCost,
      currencyISO,
    }),
  };

  if (totalCostColIndex > -1) {
    return [
      ...row.slice(0, totalCostColIndex),
      totalCostCell,
      ...row.slice(totalCostColIndex + 1),
    ];
  }

  return row;
};
